var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('title-row', {
    attrs: {
      "title": _vm.page.title,
      "breadcrumb-items": [{
        text: 'Kulcsok és eszközök',
        to: {
          name: 'AssetList'
        }
      }, _vm.page.breadcrumbItem]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.hasRight('KEY_WRITE') ? _c('title-row-button', {
          attrs: {
            "title": "Mentés"
          },
          on: {
            "click": _vm.save
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("mdi-content-save")]), _vm._v(" Mentés ")], 1) : _vm._e()];
      },
      proxy: true
    }])
  }), _vm.loading ? _c('loading-overlay') : _vm._e(), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": 12
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-key")]), _vm._v(" Alapadatok ")], 1), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": 12,
      "md": 6
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Megnevezés",
      "error-messages": _vm.errors.name,
      "filled": ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "RFID",
      "filled": "",
      "error-messages": _vm.errors.rfid,
      "hint": _vm.readerDisabled ? '' : 'Érintse a kártyát az olvasóhoz'
    },
    model: {
      value: _vm.form.rfid,
      callback: function ($$v) {
        _vm.$set(_vm.form, "rfid", $$v);
      },
      expression: "form.rfid"
    }
  }), _c('v-autocomplete', {
    attrs: {
      "label": "Kulcsszekrények",
      "items": _vm.asset_cabinets,
      "item-text": "name",
      "item-value": "id",
      "value-comparator": _vm.$config.comparators.isEqual,
      "filled": "",
      "multiple": "",
      "chips": "",
      "deletable-chips": ""
    },
    model: {
      value: _vm.form.cabinet_ids,
      callback: function ($$v) {
        _vm.$set(_vm.form, "cabinet_ids", $$v);
      },
      expression: "form.cabinet_ids"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12,
      "md": 6
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Megjegyzés",
      "name": "name",
      "filled": "",
      "auto-grow": "",
      "rows": 5
    },
    model: {
      value: _vm.form.remark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  }), _c('v-swatches', {
    attrs: {
      "inline": "",
      "swatches": ['#FF6D00', '#D50000', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#795548', '#9E9E9E', '#000000', '#FFFFFF', ''],
      "shapes": "squares",
      "show-border": "",
      "spacing-size": 4,
      "swatch-size": 32
    },
    model: {
      value: _vm.form.color,
      callback: function ($$v) {
        _vm.$set(_vm.form, "color", $$v);
      },
      expression: "form.color"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": 12
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "loading": _vm.groupsLoading
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-group")]), _vm._v(" Engedélyezett csoportok ")], 1), _c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "label": "Csoportok",
      "items": _vm.groups,
      "filled": "",
      "multiple": "",
      "item-text": "name",
      "item-value": "element_id",
      "value-comparator": _vm.$config.comparators.isEqual,
      "return-object": "",
      "hide-details": "",
      "chips": "",
      "deletable-chips": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref) {
        var item = _ref.item,
          index = _ref.index;
        return [_c('v-chip', {
          attrs: {
            "to": {
              name: 'GroupEditor',
              params: {
                id: item.element_id
              }
            },
            "target": "_blank"
          }
        }, [_c('span', [_vm._v(_vm._s(item.name))]), _c('v-btn', {
          staticClass: "ml-2",
          attrs: {
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.form.groups.splice(index);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)];
      }
    }]),
    model: {
      value: _vm.form.groups,
      callback: function ($$v) {
        _vm.$set(_vm.form, "groups", $$v);
      },
      expression: "form.groups"
    }
  })], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": 12
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cards")]), _vm._v(" Engedélyezett kártyák ")], 1), _c('v-card-text', [_c('v-two-panel-multiselect', {
    attrs: {
      "headers": [{
        text: 'Kártyaszám',
        value: 'card_number'
      }, {
        text: 'Birtokos',
        value: 'owner_name'
      }],
      "options": {
        sortBy: ['card_number']
      },
      "items": _vm.cards,
      "item-value": "element_id"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (_ref2) {
        var search = _ref2.search;
        return [_c('v-card', {
          staticClass: "mb-6",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-card-title', [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-filter")]), _vm._v(" Keresés ")], 1), _c('v-card-text', [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": 12,
            "md": 6,
            "lg": 3
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Kártyatulajdonos",
            "hide-details": ""
          },
          model: {
            value: search.owner_name,
            callback: function ($$v) {
              _vm.$set(search, "owner_name", $$v);
            },
            expression: "search.owner_name"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": 12,
            "md": 6,
            "lg": 3
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Kártyaszám",
            "hide-details": ""
          },
          model: {
            value: search.card_number,
            callback: function ($$v) {
              _vm.$set(search, "card_number", $$v);
            },
            expression: "search.card_number"
          }
        })], 1)], 1)], 1)], 1)];
      }
    }]),
    model: {
      value: _vm.form.cards,
      callback: function ($$v) {
        _vm.$set(_vm.form, "cards", $$v);
      },
      expression: "form.cards"
    }
  })], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }